import { post } from "@/utils/network";
import { requestPayload } from '@/interfaces/websocketMessageInterfaces';

export interface messageCourseList {
  "id": string, //  课程id
  "coursename": string,
  "classname": string,
  "issys":boolean, // is system made course
  "talk":boolean, // 私信权限
  "owner":true, // 是否为本人创建
  "noReadCount": string, // 未读
  "studentCount":2,
  "role":1,  // 0 student 1 teacher
  "classAdministration":Array<{ // 行政班级列表
    "id": string,
    "name": string
  }>
}

export interface friendItem {
  "friendId": string,
  "friendAvatar": string,
  "friendUsername": string,
  "courseId": string,
  "courseName": string,
  "lastMessage": number,
  "lastMessageCreateTime": string,
  "noReadCount": number
}
export const getTeachTeam = (classid: string) => {
  return post<Array<friendItem>>('/LetterApi/getTeachTeam', { classid })
}
export const getMessageBooksCourseList = () => {
  return post<Array<messageCourseList>>('/LetterApi/getCourseList', )
}

export const getClassAdministrationFriendList = (courseId: string, classId: string) => {
  return post<Array<friendItem>>('/LetterApi/getClassAdministrationFriendList', {
    classid: courseId,
    caid: classId,
  })
}

export const createGroup = (params: { friendid: string; courseid: string }) => {
  return post<{
    groupId: number,
    coursename: string
  }>('/Futurev2/Letter/createGroup', params)
}

export const getImToken = () => {
  return post<requestPayload.login>('/userApi/getIMToken', );
}

/** 避免并发重复请求 getIMToken */
let ensureImLoginPromise: Promise<requestPayload.login | null> | null = null;

/**
 * 进入私信/聊天时再登录 IM，避免一进课堂就打 getIMToken
 */
export const ensureImLogin = (wsMsgModule: {
  loginParam?: requestPayload.login;
  login: (param: requestPayload.login) => void;
}): Promise<requestPayload.login | null> => {
  if (wsMsgModule.loginParam) {
    return Promise.resolve(wsMsgModule.loginParam);
  }
  if (!localStorage.token) {
    return Promise.resolve(null);
  }
  if (!ensureImLoginPromise) {
    ensureImLoginPromise = getImToken()
      .then((res) => {
        res.pageCurrent = 1;
        res.pageSize = 50;
        wsMsgModule.loginParam = res;
        wsMsgModule.login(res);
        return res;
      })
      .catch((e) => {
        console.log(e);
        return null;
      })
      .finally(() => {
        ensureImLoginPromise = null;
      });
  }
  return ensureImLoginPromise;
}

export const getChatHistoy = (friendid:string) => {
  return post<any>('/LetterApi/getMsgList', {friendid});
}

export  default {
  getMessageBooksCourseList,
}
